/* eslint-disable max-len */
export default class ReduChartExterior {
  constructor() {
    this.elements = document.querySelectorAll('.js--reduchart-exterior');

    for (let i = 0; i < this.elements.length; i++) {
      this.drawChart(i);
    }
  }
  drawChart(i) {
    const element = this.elements[i];

    const reduchart = new Chart(element, {
      type: 'line',
      data: {
        datasets: graphDataSet['advice' + element.dataset.advice].product.exterior,
        labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        chartArea: {
          backgroundColor: '#F7F7F7',
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        animation: {
          onComplete: function () {
            let ctx = this.chart.ctx;
            for (let i = 0; i < this.data.datasets.length; i++) {
              let meta = this.controller.getDatasetMeta(i);
              let xCoord = meta.data[0]._model.x;
              let yCoord = meta.data[0]._model.y;

              let yCoordCustom = yCoord + 7;
              let xCoordCustom = xCoord + 50;
              ctx.textAlign = 'center';
              ctx.font = '20px futura-pt'
              ctx.fillStyle = '#FFFFFF';
              ctx.fillText(this.data.datasets[i].label, xCoordCustom, yCoordCustom);
            }
          }
        },
        scales: {
          xAxes: [{
            position: 'bottom',
            gridLines: {
              offsetGridLines: true,
              color: '#FFFFFF',
              lineWidth: 18,
              drawBorder: false,
              drawTicks: false,
            },
            ticks: {
              beginAtzero: false,
              display: false,
              stepSize: 1,
            },
          }],
          yAxes: [{
            gridLines: {
              display: false,
              tickMarkLength: 0,
              zeroLineWidth: 0,
            },
            scaleLabel: {
              display: false,
            },
            ticks: {
              display: false,
              beginAtZero: true,
              max: 5,
            },
          }],
        },
      },
    });
  }
}
